import { render, staticRenderFns } from "./EditNomAllowedFiletypes.vue?vue&type=template&id=297d7466&scoped=true&"
import script from "./EditNomAllowedFiletypes.ts?vue&type=script&lang=ts&"
export * from "./EditNomAllowedFiletypes.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "297d7466",
  null
  
)

export default component.exports
import {QForm,QInput,QBtn} from 'quasar'
component.options.components = Object.assign({QForm,QInput,QBtn}, component.options.components || {})
